<script setup lang="ts">
    defineProps<{ imageRight?: boolean }>();
</script>

<template>
    <svg
        aria-hidden="true"
        viewBox="0 0 1 1"
        style="fill-rule: evenodd; clip-rule: evenodd; stroke-linejoin: round; stroke-miterlimit: 2"
    >
        <defs>
            <clipPath
                :id="imageRight ? 'desktop--right' : 'desktop'"
                clipPathUnits="objectBoundingBox"
            >
                <path
                    d="M0.505,1L-0,1L-0,0.489C-0,0.219 0.222,-0 0.495,0L1,0L1,0.511C1,0.781 0.778,1 0.505,1Z"
                    style="fill: white; fill-rule: nonzero; transform-origin: center"
                    :style="imageRight ? 'transform: rotate(180deg)' : 'transform: rotate(90deg)'"
                />
            </clipPath>
        </defs>
    </svg>
</template>
